import { render, staticRenderFns } from "./Feature2.vue?vue&type=template&id=84f90cd0"
import script from "./Feature2.vue?vue&type=script&lang=js"
export * from "./Feature2.vue?vue&type=script&lang=js"
import style0 from "./Feature2.vue?vue&type=style&index=0&id=84f90cd0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports